(function (app) {

    app.provider("carrierProductApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.get = function (carrierProductId) {
                            return crmApiGateway.get("/CarrierProducts/" + carrierProductId);
                        };

                        service.getCarrierProducts = function () {
                            return crmApiGateway.getArray("/CarrierProducts");
                        };

                        service.getCarrierProductsList = function () {
                            return crmApiGateway.getArray("/CarrierProductsList");
                        };

                        service.getProductsPerCarrier = function (carrierId) {
                            return crmApiGateway.getArray("/Carriers/" + carrierId + "/CarrierProducts");
                        };

                        service.update = function (carrierProductId, carrierProduct) {
                            return crmApiGateway.put("/CarrierProducts/" + carrierProductId, carrierProduct);
                        };

                        service.updateCusip = function (carrierProductId, carrierProduct) {
                            return crmApiGateway.put("/CarrierProducts/" + carrierProductId + "/Cusip", carrierProduct);
                        };

                        service.updateFirelightCusip = function (carrierProductId, carrierProduct) {
                            return crmApiGateway.put("/CarrierProducts/" + carrierProductId + "/FirelightCusip", carrierProduct);
                        };

                        service.updateRightBridgeCusip = function (carrierProductId, carrierProduct) {
                            return crmApiGateway.put("/CarrierProducts/" + carrierProductId + "/RightBridgeCusip", carrierProduct);
                        };

                        service.updateIsActive = function (carrierProductId, carrierProduct) {
                            return crmApiGateway.put("/CarrierProducts/" + carrierProductId + "/IsActive", carrierProduct);
                        };

                        service.create = function (carrierProduct) {
                            return crmApiGateway.post("/CarrierProducts", carrierProduct);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line